// let getAllProducts = document.querySelectorAll(".collection-con li");

// window.onload = function() {
//   getAllProducts.forEach(function(item) {
//     item.classList.add("appear");
//   });
// };

window.addEventListener("load", function () {
  var swiper = new Swiper(".mobile-swiper", {
    //loop: true,
    spaceBetween: 11
  });
});